import { render, staticRenderFns } from "./complianceChipDisplay.vue?vue&type=template&id=7250a6a2&"
import script from "./complianceChipDisplay.vue?vue&type=script&lang=js&"
export * from "./complianceChipDisplay.vue?vue&type=script&lang=js&"
import style0 from "./complianceChipDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "complianceChipDisplay.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VChip,
  VIcon,
})
